const VPSHostingContentFour = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Ultra-Low Latency Execution</h4>
              </div>
              <p>
                Our VPS servers are positioned near major liquidity providers to
                deliver near-instant order execution.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>24/7 Connectivity</h4>
              </div>
              <p>
                Trade without downtime. Your strategies stay live and active,
                even when you’re offline.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Secure and Reliable Infrastructure</h4>
              </div>
              <p>
                Bank-grade encryption and server redundancy ensure maximum
                security and performance.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Compatible with MetaTrader 4 & 5</h4>
              </div>
              <p>
                Run both MT4 and MT5 terminals effortlessly for seamless
                cross-platform trading.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VPSHostingContentFour;
